import React from 'react';
import PreviousResponse from './PreviousResponse';

class PreviousResponsesTab extends React.Component {
  render() {
    const { previousAttempts } = this.props;

    return (
      <div className="TabContainer">
        <div className="d-f fd-c ff-ss">
          <ul>
            {previousAttempts.map(previousAttempt => (
              <PreviousResponse key={previousAttempt.id} {...previousAttempt} />
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default PreviousResponsesTab;
